import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment'
import 'babel-polyfill'
import Pin from 'vue-pin'



// install
Vue.use(Pin)

Vue.prototype.$moment = moment
Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
   router,
   render: h => h(App),
    store
}).$mount('#app')
